module.exports = __webpack_public_path__ + "img/fan-normal-img.a196c2c4.jpg";